import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export const PortLocationNcsTable = ({ options }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [portLocations, setPortLocations] = useState([]);
    useEffect(() => {
        if (!options.isReady) {
            setIsLoading(false);
            setHasResult(false);
            setErrorMessage("");
            setPortLocations([]);
            return;
        }
        setIsLoading(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/operational/portlocationncs?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setPortLocations(data === null ? [] : data);
            setHasResult(true);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching operational patterns");
        })
            .finally(() => setIsLoading(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "NCs by location" }), _jsxs("div", { className: "card-body", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && portLocations.length > 0 && (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm align-middle mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Port" }), _jsx("th", { className: "text-end", children: "NC Days" })] }) }), _jsx("tbody", { children: portLocations.map((portLocation) => (_jsxs("tr", { children: [_jsx("td", { children: portLocation.Port }), _jsx("td", { className: "text-end", children: portLocation.NCs })] }, portLocation.Port))) })] }) })), hasResult && !isLoading && portLocations.length === 0 && !errorMessage && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
};
